import { eachDayOfInterval, endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns';

const DAYS_IN_WEEK = 7;

/** Build a Monday-first matrix with the number of weeks required by the month. */
export function buildCalendarWeeks(month: Date): Date[][] {
  const gridStart = startOfWeek(startOfMonth(month), { weekStartsOn: 1 });
  const gridEnd = endOfWeek(endOfMonth(month), { weekStartsOn: 1 });
  const days = eachDayOfInterval({
    start: gridStart,
    end: gridEnd,
  });

  return Array.from({ length: days.length / DAYS_IN_WEEK }, (_, index) =>
    days.slice(index * DAYS_IN_WEEK, (index + 1) * DAYS_IN_WEEK),
  );
}
